        import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import AuthGuard from './components/AuthGuard';
import AuthInitializer from './components/AuthInitializer';
import ErrorBoundary from './components/ErrorBoundary';
import Toast from './components/Toast';

// Pages
import Dashboard from './pages/Dashboard';
import DashboardPreview from './pages/DashboardPreview';
import PerformanceAnalysis from './pages/PerformanceAnalysis';
import Valuations from './pages/dashboard/Valuations';
import CompetitorMapping from './pages/dashboard/CompetitorMapping';
import Analytics from './pages/Analytics';
import Valuation from './pages/Valuation';
import ValuationDemo from './pages/ValuationDemo';
import PropertySearch from './pages/PropertySearch';
import LocationAnalysis from './pages/LocationAnalysis';
import Research from './pages/Research';
import VendorList from './pages/VendorList';
import Home from './pages/Home';
import Login from './pages/Login';
import Pricing from './pages/Pricing';
import Checkout from './pages/Checkout';
import ContactSales from './pages/ContactSales';
import Signup from './pages/Signup';
import ResetPassword from './pages/ResetPassword';
import UserSettings from './pages/UserSettings';
import SubscriptionTier from './pages/SubscriptionTier'; // Kept for future use
import AuthCallback from './pages/AuthCallback';
import SetPassword from './pages/SetPassword';
import UpdatePassword from './pages/UpdatePassword';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import IndustryNews from './pages/IndustryNews';

import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Refund from './pages/Refund';
import ContactUs from './pages/ContactUs';
import FAQ from './pages/FAQ';
import Advertise from './pages/Advertise';
import DemoPage from './pages/DemoPage';
import About from './pages/About';

export default function App() {
  return (
    <ErrorBoundary>
      <AuthInitializer>
      <Routes>
        {/* Auth Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* OAuth callback route */}
        <Route path="/auth/callback" element={<AuthCallback />} />
        {/* Password setup route */}
        <Route path="/auth/set-password" element={<SetPassword />} />
        {/* Password reset route */}
        <Route path="/auth/update-password" element={<UpdatePassword />} />
        {/* Redirect subscription tier requests to signup - Google SSO is primary auth method */}
        <Route path="/subscription-tier" element={<Navigate to="/signup" replace />} />

        {/* Public Routes */}
        <Route element={<AuthGuard requireAuth={false}><Layout /></AuthGuard>}>
          <Route path="/" element={<Home />} />
          <Route path="/valuation" element={<Valuation />} />
          <Route path="/valuation-demo" element={<ValuationDemo />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/properties" element={<PropertySearch />} />
          <Route path="/location-analysis" element={<LocationAnalysis />} />
          <Route path="/research" element={<Research />} />
          <Route path="/vendors" element={<VendorList />} />
          <Route path="/dashboard-preview" element={<DashboardPreview />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/contact-sales" element={<ContactSales />} />
          <Route path="/advertise" element={<Advertise />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/industry-news" element={<IndustryNews />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund-policy" element={<Refund />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/about" element={<About />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<AuthGuard requireAuth={true}><Layout /></AuthGuard>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/valuations" element={<Valuations />} />
          <Route path="/dashboard/competitor-mapping" element={<CompetitorMapping />} />
          <Route path="/dashboard/competitor-mapping/:propertyId" element={<CompetitorMapping />} />
          <Route path="/dashboard/performance-analysis/:id" element={<PerformanceAnalysis />} />
          <Route path="/user-settings" element={<UserSettings />} />
        </Route>
      </Routes>
      <Toast />
      </AuthInitializer>
    </ErrorBoundary>
  );
}